<script>
  import {
    Header,
    AcquisitionSection,
    EasysetupSection,
    SalesSection,
    Pricing,
    FreeTrialCTA,
    Demo,
  } from "$lib/components";

  export let data;

  $: subscriptionPackages = data?.subscription_packages || [];
</script>

<Header />
<EasysetupSection />
<SalesSection />
<AcquisitionSection />
<Pricing packages={subscriptionPackages} />
<FreeTrialCTA />
<Demo />
